import React from "react";
import { Box, Link, Typography } from "@mui/material";
import CustomTabPanel from "./CustomTabPanel";

function Brands() {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "32px",
          background: "#fff",
        }}
      >
        <Box>
          <Link
            href="#"
            sx={{
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "500",
              color: "rgba(105, 106, 107, 1)",
            }}
          >
            Brands
          </Link>
          <Typography
            variant="h3"
            sx={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#000",
              marginTop: "16px",
            }}
          >
            List of Brands
          </Typography>
        </Box>
      </Box>
      <Box sx={{ background: "#fff" }}>
        <Box sx={{ width: "100%" }}>
          <CustomTabPanel />
        </Box>
      </Box>
    </div>
  );
}
export default Brands;
